import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28da68de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tooltip-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-info-circle",
  style: {"font-size":"1rem","cursor":"pointer"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showTooltip = true)),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTooltip = false)),
      class: "trigger flex items-center justify-center"
    }, [
      _renderSlot(_ctx.$slots, "trigger", {}, () => [
        _hoisted_2
      ], true)
    ], 32),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showTooltip)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["tooltip-content", _ctx.position])
            }, [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _createTextVNode("Default tooltip content")
              ], true)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}